import type { ReactNode } from 'react';
import { STATE_LABELS_FA, type DealState } from '@kia/shared';

export type ChipTone = 'neutral' | 'info' | 'warn' | 'success' | 'danger';

export function Chip({ tone = 'neutral', children }: { tone?: ChipTone; children: ReactNode }) {
  return <span className={`chip chip-${tone}`}>{children}</span>;
}

const STATE_TONE: Record<DealState, ChipTone> = {
  Inquiry: 'neutral',
  Offer: 'info',
  Confirmed: 'warn',
  Delivered: 'success',
  Closed: 'neutral',
  Lost: 'danger',
  Expired: 'danger',
  Cancelled: 'danger',
};

/** A deal-state chip with the right colour + Persian label. */
export function StatusBadge({ state }: { state: DealState }) {
  return <Chip tone={STATE_TONE[state]}>{STATE_LABELS_FA[state]}</Chip>;
}
